import { Icon, Stack } from "@introist/react-foundation/v2";
import { AssistantChat } from "./AssistantChat";

export const ASSISTANT_ROUTES = {
  assistant: {
    key: "assistant",
    path: "/assistant",
    element: (
      <Stack vertical justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
        <AssistantChat />
      </Stack>
    ),
    title: "Assistant",
    icon: <Icon name="robot" />
  }
};
